export function issueCommentAnchor(commentId: string, anchorPrefix?: string): string {
  return `${anchorPrefix ?? ''}issuecomment-${commentId}`
}

export function reviewSummaryAnchor(reviewId: string, anchorPrefix?: string): string {
  return `${anchorPrefix ?? ''}pullrequestreview-${reviewId}`
}

export function threadCommentAnchorPrefix(anchorPrefix?: string): string {
  // This matches the canonical public review-comment fragment.
  return `${anchorPrefix ?? ''}discussion_r`
}
